module.exports = __webpack_public_path__ + "img/marker_office.1eba6ff.svg";